import { render, staticRenderFns } from "./editVideo.vue?vue&type=template&id=50c71e3a&scoped=true&"
import script from "./editVideo.vue?vue&type=script&lang=js&"
export * from "./editVideo.vue?vue&type=script&lang=js&"
import style0 from "./editVideo.vue?vue&type=style&index=0&id=50c71e3a&prod&scoped=true&lang=css&"
import style1 from "./editVideo.vue?vue&type=style&index=1&id=50c71e3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c71e3a",
  null
  
)

export default component.exports